/* eslint-disable */

/**
 * Customer preference for handling incoming requests for payment (i.e. bills).
 * Relates to column "incoming_request_policy" in table "profile_assets".
 */
export enum IncomingRequestPolicy {
  /** ALLOW_ALL - Allow anybody to send bills to the customer. */
  ALLOW_ALL = "ALLOW_ALL",
  /** ALLOW_CONTACTS - Only allow contacts (synced and past payment) to send bills to the customer. */
  ALLOW_CONTACTS = "ALLOW_CONTACTS",
  /** DENY_ALL - Do not allow anybody to send bills to the customer. */
  DENY_ALL = "DENY_ALL",
}
